import React from 'react';
import styles from './AppImportSummaryContainer.module.scss';

interface Props {
  children: React.ReactNode;
}

const AppImportSummaryContainer: React.FC<Props> = props => {
  return <article className={styles.container}>{props.children}</article>;
};

export default AppImportSummaryContainer;
